import SearchLayout from "@components/Layouts/SearchLayout"
import { Hits } from "@components/Search/Hits"
import SearchSeo from "@components/Search/SearchSeo"
import {
  GetServerSideProps,
  GetServerSidePropsContext,
  InferGetServerSidePropsType,
} from "next"
import { renderToString } from "react-dom/server"
import { getServerState } from "react-instantsearch-core"

const Search = ({
  serverState,
  serverUrl,
}: InferGetServerSidePropsType<typeof getServerSideProps>) => {
  return (
    <SearchLayout
      serverUrl={serverUrl}
      serverState={serverState}
    >
      <SearchSeo />
      <Hits />
    </SearchLayout>
  )
}

export default Search

export const getServerSideProps: GetServerSideProps = async ({
  req,
}: GetServerSidePropsContext) => {
  const protocol = req.headers.referer?.split("://")[0] || "https"
  const serverUrl = `${protocol}://${req.headers.host}${req.url}`
  const serverState = await getServerState(<Search serverUrl={serverUrl} />, {
    renderToString,
  })

  return {
    props: {
      serverState,
      serverUrl,
    },
  }
}
